import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';


@Injectable()
export class AdresseipService {
  private url = '//freegeoip.net/json/?callback='
  constructor(private http: Http){}

  get() {
    return this.http.get(this.url)
    .toPromise()
    .then(response => {
        return response.json();
    })
    .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    return Promise.reject(error.message || error);
  }
}



// WEBPACK FOOTER //
// /Users/mac-jeremy/Projets/fairepart/src/app/home/adresseip.service.ts